import { IChartContainer } from "../models/base/chart-container.interface";
import { TradeOrderDataModel } from "../models/draw-trade-order/trade-order-data.model";
import { IComponent } from "./component.interface";
import { TradePlotLineComponent } from "./trade-plot-line.component";

export class DrawTradeOrdersComponent implements IComponent {
    public id = '';

    private base: IChartContainer;
    private tradeOrders: Array<TradeOrderDataModel> = [];
    private tradePlotLines: Array<TradePlotLineComponent> = [];
    private isRemovingForSwitchingSymbol = false;
    private canDraw = false;

    constructor(base: IChartContainer) {
        this.base = base;
        
        if (!this.base.marketingWebChartMode) {
            this.canDraw = true;
        }

        // setTimeout(() => {
        //     this.subscribeDrawTradeOrders();
        // }, 5000)
        this.subscribeDrawTradeOrders();
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        if (this.base.marketingWebChartMode) {
            this.canDraw = false;
        }
        
        for (let i = 0; i < this.tradePlotLines.length; i++) {
            this.tradePlotLines[i].remove();
            this.tradePlotLines[i] = null;
        }

        this.tradeOrders = [];
        this.tradePlotLines = [];

        this.isRemovingForSwitchingSymbol = false;
    }

    public enable() {
        if (this.canDraw) return;
        
        this.canDraw = true;
        this.updateTrades();
    }

    public disable() {
        this.canDraw = false;
        for (let i = 0; i < this.tradePlotLines.length; i++) {
            this.tradePlotLines[i].remove();
            this.tradePlotLines[i] = null;
        }

        this.tradePlotLines = [];

    }

    private drawTradeOrdersTimer: any;
    private subscribeDrawTradeOrders() {
        this.base.chartService.subscribeDrawTradeOrdersData((tradeOrders: Array<TradeOrderDataModel>) => {
            // const tradeOrderss = [
            //     new TradeOrderDataModel({id: '1', price: 1.17, color: {r: 0, g: 0, b: 255}, text: 'test', allowMoving: true, isLong: true}),
            //     new TradeOrderDataModel({id: '2', price: 1.10, color: {r: 255, g: 0, b: 0}, text: 'test', allowMoving: true, isLong: false})
            // ]

            // if (this.tradeOrders?.length) {return;}

            if (this.isRemovingForSwitchingSymbol) {
                return;
            }

            this.tradeOrders = [];
            for (const t of tradeOrders) {
                if (!!t.ocaGroup) {
                    continue;
                }

                this.tradeOrders.push(t);
            }
            
            this.updateTrades();
        });
    }

    private updateTrades() {  
        if (!this.canDraw) return;

        if (this.base.marketingWebChartMode) {
            for (const tradeOrder of this.tradeOrders) {
                const id = tradeOrder.getClassName();
                const existPlotLine = this.tradePlotLines.find((x: TradePlotLineComponent) => x.id == id);
                if (existPlotLine && existPlotLine.model && !existPlotLine.moveMode && !existPlotLine.selected) {
                    existPlotLine.model.price = tradeOrder.price;
                    existPlotLine.model.limitPrice = tradeOrder.limitPrice;
                    existPlotLine.model.stopPrice = tradeOrder.stopPrice;

                    if (existPlotLine.model.allowMoving != tradeOrder.allowMoving) {
                        existPlotLine.update(tradeOrder);
                    }
                }
            }
        } 
        
        clearTimeout(this.drawTradeOrdersTimer);
        this.drawTradeOrdersTimer = setTimeout(() => {
            const anyPlotLineMoving = this.tradePlotLines.some((x: TradePlotLineComponent) => x.moveMode || x.selected);
            if (anyPlotLineMoving) {
                this.updateTrades();
                return;
            }

            this.removeTradePlotLinesAfterUpdate();
            this.createTradePlotLines();
        }, 300);
    }

    private removeTradePlotLinesAfterUpdate() {
        const plotLinesToRemove: Array<number> = [];
        for (let i = 0; i < this.tradePlotLines.length; i++) {
            if (!this.tradeOrders.some((x: TradeOrderDataModel) => x.getClassName() == this.tradePlotLines[i].id)) {
                plotLinesToRemove.push(i);
                this.tradePlotLines[i].remove();
                this.tradePlotLines[i] = null;
            }
        }

        if (plotLinesToRemove.length) {
            for (const index of plotLinesToRemove) {
                this.tradePlotLines.splice(index);
            }
        }
    }

    private createTradePlotLines() {
        for (const tradeOrder of this.tradeOrders) {
            const id = tradeOrder.getClassName();
            const existPlotLine = this.tradePlotLines.find((x: TradePlotLineComponent) => x.id == id);
            if (existPlotLine) {
                existPlotLine.update(tradeOrder);
            } else {
                this.tradePlotLines.push(new TradePlotLineComponent(this.base, tradeOrder));
            }
        }
    }
}